module.exports = __webpack_public_path__ + "static/media/loading.c02681f0.gif";